(function () {

    'use strict';

    angular.module('app').controller('CarriersExternalProfilesEditController', CarriersExternalProfilesEditController);

    CarriersExternalProfilesEditController.$inject = [
        '$location',
        '$timeout',
        '$q',
        '$scope',
        '$routeParams',
        'Carrier',
        'ConfirmationModalFactory',
        '$uibModal',
        '$filter',
        'toastr',
        'CarrierSettingsTableService',
        'ViewChangeNotificationFactory',
        'hasDuplicate',
        '$window',
        'isUniqueService',
        'ResellerListTable',
        'scrollToForm',
        'CropperModalService',
        '$rootScope',
        'WarningModalFactory',
        'CarrierProfileTrackingTableService',
        'ClientService',
        'AdminPermissionService',
        'PermissionHelpers'
    ];

    function CarriersExternalProfilesEditController(
        $location,
        $timeout,
        $q,
        $scope,
        $routeParams,
        Carrier,
        ConfirmationModalFactory,
        $uibModal,
        $filter,
        toastr,
        CarrierSettingsTableService,
        ViewChangeNotificationFactory,
        hasDuplicate,
        $window,
        isUniqueService,
        ResellerListTable,
        scrollToForm,
        CropperModalService,
        $rootScope,
        WarningModalFactory,
        CarrierProfileTrackingTableService,
        ClientService,
        AdminPermissionService,
        PermissionHelpers
    ) {
        var vm = this;
        let CarrierSettingsTable = null;
        let CarrierProfileTrackingTable = null;
        vm.params = $routeParams || {};
        vm.carrierProfileLogoDimensions = { width: 1200, height: 1200 };
        vm.id = vm.params.id === 'new' ? false : vm.params.id || false;
        vm.userCompanyId = $rootScope.GlobalProfile.company.id;
        vm.networkSharingChange = networkSharingChange;
        vm.activeStatusChanged = activeStatusChanged;
        vm.isUnique = isUnique;
        vm.origName = undefined;
        vm.cloneCarrier = cloneCarrier;
        vm.back = back;
        vm.save = save;
        vm.isCarriersInvalid = isCarriersInvalid;
        vm.openCropper = openCropper;
        vm.updateLogo = updateLogo;

        const cropperModal = new CropperModalService();
        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const enableCarrierSharingConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.enableCarrierSharing.MESSAGE',
            code: 'messages.warning.enableCarrierSharing.CODE',
        });
        const disableCarrierSharingConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.disableCarrierSharing.MESSAGE',
            code: 'messages.warning.disableCarrierSharing.CODE',
        });
        const toActiveStatus = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.TO_CARRIER_PROFILE_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });
        const toInActiveStatus = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.TO_CARRIER_PROFILE_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });
        const shareCarrierProfileToAllServiceProfileConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.shareCarrierProfileToAllServiceProfile.MESSAGE',
            code: '',
        });
        const selectResellersWaringModal = new WarningModalFactory({}, {
            message: 'messages.warning.selectResellersWarning.MESSAGE',
            code: ''
        });

        const onRouteChange = $scope.$on('$routeChangeStart', function (event, next) {
            if (!vm.isViewMode && isDataTouched()) {
                viewConfirmation.getInstance().result.then(function (cond) {
                    if (cond) {
                        onRouteChange();
                        let nextRoute = next.$$route.originalPath;
                        if (_.contains(next.$$route.originalPath, ':')) {
                            nextRoute = nextRoute.split(':')[0];
                        }
                        $location.path(nextRoute);
                    }
                });
                event.preventDefault();
            }
        });

        vm.carrier = {
            settings: [],
            networkEffects: {
                resellers: []
            }
        };

        vm.statusSwitch = {
            true: $filter('translate')('labels.status.ACTIVE'),
            false: $filter('translate')('labels.status.INACTIVE'),
        };

        vm.networkSwitch = {
            true: $filter('translate')('labels.switch.ENABLE'),
            false: $filter('translate')('labels.switch.DISABLE'),
        };

        vm.autoReconcileSwitch = {
            true: $filter('translate')('labels.switch.ENABLE'),
            false: $filter('translate')('labels.switch.DISABLE'),
        };

        init();

        function init() {
            setIsAdmin();
            setIsHideRatesEngine();
            getAllCompany();
            if (vm.id) {
                loadCarrierProfileData();
                return;
            }

            loadCreateFormData();
        }

        function setIsHideRatesEngine() {
            AdminPermissionService.AdminCurrentUser.getAdminUserDetails(success => {
                const moduleAccess = [];
                success.content.forEach(user => {
                    user.modules.forEach(module => {
                        moduleAccess.push(module.name);
                    });
                });
                vm.isHideRatesEngine = PermissionHelpers.isHideRatesEngine(moduleAccess);
            }, error => { }, $rootScope.GlobalProfile.id);
        }

        function loadCarrierProfileData() {
            vm.isFetching = true;
            vm.loadingMessage = 'Please wait while we are loading your data';
            $q.all({
                carriers: getCarriers(),
                carrierProfile: getCarrierProfile(),
                serviceProfiles: getCarrierServiceProfiles(),
                companyList: getAllCompany()
            }).then(function (data) {
                vm.carriers = data.carriers
                vm.carrierProfile = data.carrierProfile;
                vm.serviceProfiles = data.serviceProfiles.content;
                vm.companyList = data.companyList;
                vm.isReceiver = isCarrierReceiver();

                buildCarrierTrackingTable(vm.carrierProfile.trackingConfigurations)

                buildCarrierProfile(vm.carrierProfile);
                vm.isFetching = false;
            }, error => {
                toastr.error(error.message, 'Error!');
                redirectToCarrierProfiles();
            });
        }

        function isCarrierReceiver() {
            return !vm.carrierProfile.owned;
        }

        function loadCreateFormData() {
            vm.isFetching = true;
            getCarriers().then(data => {
                vm.carriers = data;
                buildCarrierTrackingTable([])
                buildCarrierSettingsTable([]);
                buildCarrierNetworkTable();
                vm.isFetching = false;
            });
        }

        function redirectToCarrierProfiles() {
            $location.path('/carriers/carrier-profiles')
        }

        function getAllCompany() {
            const defer = $q.defer();

            ClientService.Company.getAll(
                (data) => defer.resolve(data),
                (error) => defer.reject(error), { size: 500 });
            return defer.promise;

        }

        function getCarrierServiceProfiles() {
            const defer = $q.defer();

            Carrier.getServiceProfiles(data => {
                defer.resolve(data);
            }, error => {
                defer.reject(error);
                toastr.error(error.message, 'Error');
            }, {
                'carrierProfile.id': vm.id,
                size: 25
            });

            return defer.promise;
        }

        function isCarriersInvalid(form) {
            if (form.carriersList) {
                return (form.carriersList.$invalid && form.carriersList.$touched) || (form.carriersList.$invalid && form.$submitted);
            } else {
                return false;
            }
        }

        function isDataTouched() {
            return !angular.equals(vm.carrier, vm.carrierRaw)
                || !angular.equals(vm.carrierRaw.settings, CarrierSettingsTable.getSettingsPayload());
        }

        function setIsAdmin() {
            const isFound = $rootScope.GlobalProfile.permissionGroup.roles.find(role => role.code === 'ROLE_ADMIN');
            vm.isAdmin = !!isFound;
            console.log(vm.isAdmin)
        }

        function networkSharingChange(event) {
            event.preventDefault();
            $timeout(() => {
                if (vm.carrier.networkEffectEnabled) {
                    vm.carrier.networkEffectEnabled = false;
                    enableCarrierSharingConfirmation.getInstance().result.then(function (cond) {
                        if (cond) {
                            vm.carrier.networkEffectEnabled = true;
                        }
                    });
                } else {
                    vm.carrier.networkEffectEnabled = true;
                    disableCarrierSharingConfirmation.getInstance().result.then(function (cond) {
                        if (cond) {
                            vm.carrier.networkEffectEnabled = false;
                        }
                    });
                }
            });
        }

        function activeStatusChanged(event) {
            event.preventDefault();
            $timeout(() => {
                if (vm.carrier.active) {
                    vm.carrier.active = false;
                    toActiveStatus.getInstance().result.then((cond) => {
                        if (cond) {
                            vm.carrier.active = true;
                        }
                    });
                } else {
                    vm.carrier.active = true;
                    toInActiveStatus.getInstance().result.then((cond) => {
                        if (cond) {
                            vm.carrier.active = false;
                        }
                    });
                }
            });
        }

        function getMappedSettings(carrierSettings, profileSettings) {
            let options = [];
            angular.forEach(carrierSettings, carrierSetting => {
                const matchSetting = profileSettings ? profileSettings.find(profileSetting => profileSetting.name === carrierSetting.name) : null;
                options.push({
                    name: matchSetting ? matchSetting.name : carrierSetting.name,
                    description: matchSetting ? matchSetting.description : carrierSetting.description,
                    value: matchSetting ? matchSetting.value : carrierSetting.value,
                    valueList: matchSetting ? matchSetting.valueList : null,
                    valueType: matchSetting ? matchSetting.valueType : null,
                    mandatory: carrierSetting.mandatory,
                    prerequisiteSettings: carrierSetting.prerequisiteSettings,
                    options: carrierSetting && carrierSetting.option ? {
                        true: angular.getObjVal(carrierSetting, 'option.vtrue'),
                        false: angular.getObjVal(carrierSetting, 'option.vfalse')
                    } : null
                });
            });

            return options;
        }

        function buildCarrierProfile(data) {
            vm.origName = data.name;
            let mappedSettings;
            vm.carrier = data;
            vm.carrierOrigName = angular.copy(data.name);

            initFields(vm.carriers, vm.carrier);

            if (vm.parentCarrier.settings && vm.carrier.settings) {
                mappedSettings = getMappedSettings(vm.parentCarrier.settings, vm.carrier.settings);
            }

            vm.isFetching = false;
            buildCarrierSettingsTable(mappedSettings || []);
            buildCarrierNetworkTable();
            $timeout(() => vm.carrierRaw = angular.copy(vm.carrier));
        }

        function buildCarrierSettingsTable(mappedSettings) {
            vm.settingsTable = null;
            $timeout(() => {
                CarrierSettingsTable = new CarrierSettingsTableService(mappedSettings);
                vm.settingsTable = CarrierSettingsTable.buildSettings();
                vm.carrier.settings = CarrierSettingsTable.getSettingsPayload();
            });
        }

        function buildCarrierTrackingTable(data) {
            CarrierProfileTrackingTable = new CarrierProfileTrackingTableService(data, vm.companyList);
            vm.trackingConfigTable = CarrierProfileTrackingTable.tableData;

        }

        function buildCarrierNetworkTable() {
            vm.resellersTableInstance = new ResellerListTable(vm.carrier.networkEffects);
            vm.resellerListTable = vm.resellersTableInstance.tableData;
        }

        function initFields(carriers, profile) {
            initCarrierDropdown(carriers, profile);
            angular.extend(profile, {
                networkEffects: profile.networkEffects || {
                    resellers: []
                }
            });
        }

        function initCarrierDropdown(carriers, profile) {
            vm.parentCarrier = carriers.find((carrier) => carrier.id === angular.getObjVal(profile, 'carrier.id'));
            if (!vm.parentCarrier) {
                vm.parentCarrier = carriers[0];
            }
            profile.carrierId = vm.parentCarrier.id;
        }

        function getCarriers() {
            const defer = $q.defer();

            Carrier.getCarriers(
                (data) => defer.resolve(data),
                (error) => defer.reject(error));
            return defer.promise;
        }

        function getCarrierProfile() {
            const defer = $q.defer();
            Carrier.getExternalCarrierProfile(vm.id,
                (data) => defer.resolve(data),
                (error) => defer.reject(error));
            return defer.promise;
        }

        function cloneCarrier(carrier) {
            const carrierCopy = angular.copy(carrier);
            vm.carrier.suburb = carrierCopy.suburb;
            vm.carrier.email = carrierCopy.email;
            vm.carrier.website = carrierCopy.website;
            vm.carrier.phone1 = carrierCopy.phone1;
            vm.carrier.phone2 = carrierCopy.phone2;
            vm.carrier.address1 = carrierCopy.address1;
            vm.carrier.address2 = carrierCopy.address2;
            vm.carrier.postcode = carrierCopy.postcode;
            vm.carrier.primaryContact = carrierCopy.primaryContact;
            vm.carrier.carrierId = carrierCopy.id;
            vm.carrier.name = carrierCopy.name;
            vm.carrier.location = carrierCopy.location;
            vm.carrier.settings = [];
            buildCarrierSettingsTable(getMappedSettings(carrier.settings, vm.carrier.settings));
        }

        function back() {
            $window.history.back();
        }

        function cleanPayload(data) {
            const payload = {
                carrierId: data.carrierId,
                email: data.email,
                website: data.website,
                phone1: data.phone1,
                phone2: data.phone2,
                address1: data.address1,
                address2: data.address2,
                logoUrl: data.logoUrl,
                directCarrierTracking: data.directCarrierTracking,
                primaryContact: {
                    firstName: angular.getObjVal(data, 'primaryContact.firstName'),
                    lastName: angular.getObjVal(data, 'primaryContact.lastName'),
                    email: angular.getObjVal(data, 'primaryContact.email'),
                    phone1: angular.getObjVal(data, 'primaryContact.phone1'),
                    phone2: angular.getObjVal(data, 'primaryContact.phone2')
                },
                networkEffectEnabled: data.networkEffectEnabled || false,
                serviceProfileNetworkEffects: data.serviceProfileNetworkEffects,
                name: data.name,
                locationId: angular.getObjVal(data, 'location.id'),
                location: data.location,
                active: !!data.active,
                settings: CarrierSettingsTable.getSettingsPayload(),
                trackingConfigurations: CarrierProfileTrackingTable.getTrackingConfigPayload(),
                accountingSetting: {
                    autoReconcile: angular.getObjVal(data, 'accountingSetting.autoReconcile') ? data.accountingSetting.autoReconcile : false
                }
            };
            return payload;
        }

        function save(...forms) {
            if (vm.carrier.networkEffectEnabled) {
                showShareToAllServiceProfileDialog(forms);
                return;
            }

            updateOrCreateCarrierProfile(forms);
        }

        function updateOrCreateCarrierProfile(forms) {
            if (vm.id) {
                updateCarrierProfile(forms);
                return;
            }
            saveCarrierProfile(forms);
        }

        function updateCarrierProfile(forms) {
            const invalidForm = getInvalidForms(forms);
            if (invalidForm) {
                setFormsAsSubmitted(forms);
                scrollToInvalidForm(invalidForm);
                toastr.warning('Please check the forms for invalid input');
                return;
            }

            vm.isFetching = true;
            vm.loadingMessage = 'Please wait while we are updating your data'
            CarrierSettingsTable.setSubmitted();

            const payload = cleanPayload(vm.carrier);
            callUpdateCarrierProfileApi(payload).then(data => {
                if (!vm.carrierProfileLogo) {
                    buildCarrierProfile(data)
                    buildCarrierTrackingTable(data.trackingConfigurations);
                    vm.isFetching = false;
                    return;
                }

                vm.loadingMessage = 'Please wait while we are uploading your logo';
                uploadCarrierProfileLogo(vm.carrierProfileLogo, data.id).then(() => {
                    buildCarrierProfile(data);
                    vm.isFetching = false;
                }, error => {
                    toastr.error('Error!', error.message);
                    buildCarrierProfile(data);
                });
            }, error => {
                showApiErrorMessage(error);
                vm.isFetching = false;
            });
        }

        function callUpdateCarrierProfileApi(payload) {
            const defer = $q.defer();
            Carrier.updateExternalCarrierProfile(vm.id, payload, success => {
                defer.resolve(success);
            }, error => {
                defer.reject(error.message);
            });
            return defer.promise;
        }

        function saveCarrierProfile(forms) {
            const invalidForm = getInvalidForms(forms);
            if (invalidForm) {
                setFormsAsSubmitted(forms);
                scrollToInvalidForm(invalidForm);
                toastr.warning('Please check the forms for invalid input');
                return;
            }

            vm.isFetching = true;
            CarrierSettingsTable.setSubmitted();

            const payload = cleanPayload(vm.carrier);
            callSaveCarrierProfileApi(payload).then(data => {
                if (!vm.carrierProfileLogo) {
                    vm.isFetching = false;
                    onRouteChange();
                    $location.path('/carriers/carrier-profiles/' + data.id);
                }

                vm.loadingMessage = 'Please wait while we are uploading your logo';
                uploadCarrierProfileLogo(vm.carrierProfileLogo, data.id).then(() => {
                    vm.isFetching = false;
                    onRouteChange();
                    $location.path('/carriers/carrier-profiles/' + data.id);
                });
            }, error => {
                showApiErrorMessage(error);
                vm.isFetching = false;
            });
        }

        function callSaveCarrierProfileApi(payload) {
            const defer = $q.defer();

            Carrier.createExternalCarrierProfile(payload, success => {
                defer.resolve(success);
            }, error => {
                defer.reject(error)
            });

            return defer.promise;
        }

        function getInvalidForms(forms) {
            return forms.find(frm => frm.$invalid);
        }

        function setFormsAsSubmitted(forms) {
            forms.every(form => {
                form.$setSubmitted();
            });
        }

        function scrollToInvalidForm(invalidForm) {
            scrollToForm(invalidForm.$name);
        }

        function showApiErrorMessage(error) {
            if (angular.isUndefined(error.code) && angular.isUndefined(error.message)) {
                toastr.error(error.message, 'Error!');
                return;
            }

            if (angular.isDefined(error.fieldErrors.value)) {
                vm.settingsFormError = error.fieldErrors;
                CarrierSettingsTable.setErrors(error.fieldErrors);
                toastr.warning(error.fieldErrors.value, error.code);
                return;
            }

            toastr.warning('Error', error);
        }

        function showShareToAllServiceProfileDialog(forms) {
            shareCarrierProfileToAllServiceProfileConfirmation.getInstance().result.then(function (cond) {
                if (cond) {
                    generateServiceProfileNetworkEffects(forms).then(() => {
                        updateOrCreateCarrierProfile(forms);
                    });
                    return;
                }

                showShareMarginsPopups(forms);
            });
        }


        function getSelectedNetworkEffectResellers() {
            return vm.resellersTableInstance.getSelectedRows();
        }

        function generateServiceProfileNetworkEffects(forms, networkEffectsData = null) {
            const defer = $q.defer();
            vm.carrier.serviceProfileNetworkEffects = [];
            vm.serviceProfiles.forEach(serviceProfile => {
                vm.carrier.serviceProfileNetworkEffects.push({
                    networkEffects: networkEffectsData,
                    serviceProfileId: serviceProfile.id
                });
            });

            defer.resolve();
            return defer.promise;
        }

        function showShareMarginsPopups(forms) {
            const selectedResellers = getSelectedNetworkEffectResellers();
            const service = []
            if (selectedResellers.length < 1) return;

            // todo: need to refactor this code here
            for (let i = 0; i < vm.serviceProfiles.length; i++) {
                if (vm.serviceProfiles[i].marginEnabled) {
                    service.push(vm.serviceProfiles[i].id)
                }
            }
            vm.carrier.serviceProfileNetworkEffects = [];

            showShareMarginsModal(selectedResellers, forms);
        }

        function showShareMarginsModal(
            selectedResellers,
            forms
        ) {
            const modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/modal/carrier-details-share-margins-modal.html',
                controller: 'CarrierDetailsShareMarginsModalController',
                controllerAs: 'vm',
                size: 'md',
                appendTo: $('body'),
                resolve: {
                    selectedResellers: function () {
                        return selectedResellers;
                    },
                    carrierProfileId: function () {
                        return vm.carrier.id;
                    },
                    networkEffects: function () {
                        return vm.carrier.networkEffects;
                    },
                    serviceProfiles: function () {
                        return vm.serviceProfiles;
                    }
                }
            });

            modalInstance.result.then(function (data) {
                vm.carrier.serviceProfileNetworkEffects = data;
                updateOrCreateCarrierProfile(forms);
            });
        }

        function isUnique(model, formField, origVal, prop) {
            let params = {};
            params.model = model;
            params.origName = origVal;
            params.formField = formField;
            params.service = Carrier;
            params.serviceMethod = "getExternalCarrierProfiles";
            params.property = prop;
            params.warningMsg = `${prop} is already taken`;
            isUniqueService.isUnique(params);
        }

        function uploadCarrierProfileLogo(file, id) {
            const defer = $q.defer();
            Carrier.uploadCarrierProfileLogo(file, id, () => {
                toastr.success('Logo successfully updated');
                defer.resolve();
            }, error => {
                toastr.error(error.message);
                defer.reject();
            });
            return defer.promise;
        }

        function updateLogo() {
            vm.isUploadingLogo = true;
            if (!vm.carrierProfileLogo) {
                vm.isUploadingLogo = false;
                return;
            }

            uploadCarrierProfileLogo(vm.carrierProfileLogo, data.id).then(() => {
                vm.isFetching = false;
                onRouteChange();
                $location.path('/carriers/carrier-profiles/' + data.id);
            });
        }

        function openCropper(load, fieldName) {
            cropperModal.setImageFile(load);
            cropperModal.getInstance().result.then(newImage => {
                vm[fieldName] = cropperModal.dataURItoBlob(newImage, load.$ngfName);
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/carriers/CarriersExternalProfilesEditController.js